import { ApolloClient, ApolloLink, createHttpLink, from, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

import { GRAPHQL_URI } from '../constants/config';
import { AUTHORITY } from '../constants/common';
import { navigateToBaseUrl } from '../utils/navigator';
import { UNAUTHORIZED_WORKSPACE_ACCESS } from '../constants/routes';

const httpLink = createHttpLink({
  uri: GRAPHQL_URI,
  credentials: 'include',
});

const ERROR_RESPONSE = {
  'Workspace Profile not found': () => navigateToBaseUrl(`/${UNAUTHORIZED_WORKSPACE_ACCESS}`),
  'Context creation failed: Invalid authorization': () => window.location.reload(),
};

const apollo = () => {
  const apolloLink = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        Authority: sessionStorage.getItem(AUTHORITY),
        ...operation.getContext().headers,
      },
    });
    return forward(operation);
  });

  const client = new ApolloClient({
    link: from([
      onError(({ graphQLErrors }) => {
        if (graphQLErrors && graphQLErrors.length > 0 && ERROR_RESPONSE[graphQLErrors[0].message]) {
          ERROR_RESPONSE[graphQLErrors[0].message]();
        }
      }),
      apolloLink,
    ]).concat(httpLink),
    cache: new InMemoryCache(),
  });
  return client;
};

const APOLLO_CLIENT = apollo();

export default APOLLO_CLIENT;
